import { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

function Contact() {
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
    window.scrollTo(0, 0);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <>
      {/* Page Header */}
      <section className="page-header">
        <div className="container text-center">
          <h1 className="fw-bold text-white" data-aos="fade-down">Get In Touch</h1>
          <p className="text-white-50 mt-2" data-aos="fade-up">
            Ready to start your journey? We're here to help
          </p>
        </div>
      </section>

      <section className="py-5">
        <div className="container">
          <div className="row g-5">
            {/* Contact Info */}
            <div className="col-lg-5" data-aos="fade-right">
              <h3 className="fw-bold mb-4">Let's Connect</h3>

              <div className="contact-info-card mb-3">
                <i className="bi bi-geo-alt-fill"></i>
                <div>
                  <h6 className="mb-0 fw-semibold">Visit Us</h6>
                  <p className="text-muted small mb-0">GEN Skill College, Kerala, India</p>
                </div>
              </div>

              <div className="contact-info-card mb-3">
                <i className="bi bi-envelope-fill"></i>
                <div>
                  <h6 className="mb-0 fw-semibold">Email Us</h6>
                  <p className="text-muted small mb-0">support@gencollege.in</p>
                </div>
              </div>

              <div className="contact-info-card mb-3">
                <i className="bi bi-telephone-fill"></i>
                <div>
                  <h6 className="mb-0 fw-semibold">Call Us</h6>
                  <p className="text-muted small mb-0">+91 9207833844</p>
                </div>
              </div>

              <div className="contact-info-card">
                <i className="bi bi-clock-fill"></i>
                <div>
                  <h6 className="mb-0 fw-semibold">Office Hours</h6>
                  <p className="text-muted small mb-0">Mon - Sat: 9:00 AM - 6:00 PM</p>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="col-lg-7" data-aos="fade-left">
              {submitted ? (
                <div className="text-center py-5">
                  <i className="bi bi-check-circle-fill text-success" style={{ fontSize: "4rem" }}></i>
                  <h4 className="mt-3 fw-bold">Thank You!</h4>
                  <p className="text-muted">We've received your enquiry. Our team will contact you within 24 hours.</p>
                </div>
              ) : (
                <form className="contact-form" onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label fw-medium">Full Name</label>
                      <input type="text" className="form-control" placeholder="Your name" required />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-medium">Phone</label>
                      <input type="tel" className="form-control" placeholder="+91 XXXXX XXXXX" required />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-medium">Email</label>
                      <input type="email" className="form-control" placeholder="you@email.com" required />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label fw-medium">Interested Program</label>
                      <select className="form-select" required>
                        <option value="">Select a program</option>
                        <option>AI Filmmaking</option>
                        <option>Remedial Education</option>
                        <option>Wealth Management</option>
                        <option>Business Automation</option>
                        <option>Digital Marketing</option>
                        <option>Data Analytics</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label fw-medium">Message</label>
                      <textarea className="form-control" rows="4" placeholder="Tell us about your goals..."></textarea>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn btn-primary-custom px-5 py-2">
                        Submit Enquiry <i className="bi bi-send ms-2"></i>
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Contact;
